import { render, staticRenderFns } from "./fabricacion.vue?vue&type=template&id=e6de7ddc&"
import script from "./fabricacion.vue?vue&type=script&lang=js&"
export * from "./fabricacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports